var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultTechImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 75,
    r: 75,
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultTechImage);
export default __webpack_public_path__ + "static/media/default-tech-image.fd0eff57162a7899d8da2ddf22d2d72f.svg";
export { ForwardRef as ReactComponent };